import LocationMap from "@/components/Common/LocationMap/LocationMap.vue";
import OptionListDialog from "@/components/Common/OptionListDialog/OptionListDialog.vue";
import {
  checkPlz,
  mapOptionDialogConfig
} from "@/configuration/formConfigurations";
import {
  getCoordinatesByAddress,
  getPrincipalName,
  getIsOwnedBySubPrincipalWarningHTML
} from "@/helpers/commonHelper";

export default {
  name: "EventOrganizerEditDialog",
  data: () => ({
    zoom: 17,
    isValid: false,
    noCoordinates: false
  }),
  props: ["editedItem", "showDialog", "users"],
  computed: {
    isOwnedBySubPrincipalWarningHTML() {
      const principalName = this.getPrincipalName(this.editedItem.principal_id);
      return this.getIsOwnedBySubPrincipalWarningHTML(principalName);
    },

    cShowDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        if (!val) {
          this.$refs.editForm.reset();
          this.$emit("closeDialog");
        }
      }
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    isOwnedBySubPrincipal() {
      if (!this.editedItem.principal_id?.length) {
        return false;
      }
      return this.editedItem.principal_id !== this.selectedPrincipal?._id;
    },
    originIsPoi() {
      return !!this.editedItem?.poi_id?.length;
    },
    isValidDiff() {
      if (!this.isOwnedBySubPrincipal) {
        return true;
      }
      // Additional Checks not needed for OpLoc; No valid fields possible.
      // Use extra property for consistency with other components.
      return false;
    }
  },
  methods: {
    getPrincipalName,
    getIsOwnedBySubPrincipalWarningHTML,
    async openPoi() {
      await this.save(false);
      window.open(`/poi/pois/${this.editedItem.poi_id}`, "_blank");
    },
    cancelEdit() {
      this.cShowDialog = false;
      window.location.href = "/events/oplocs";
    },
    save(close) {
      if (this.noCoordinates) delete this.editedItem.geo;
      this.$emit("save", close);
    },
    checkPlz,
    updatePosition(geo) {
      this.$set(this.editedItem.geo, "coordinates", [geo.lng, geo.lat]);
      this.$forceUpdate();
    },
    async getCoordinates() {
      const res = await getCoordinatesByAddress(
        this.editedItem?.address,
        this.$refs.optionDialog,
        mapOptionDialogConfig
      );
      if (res?.status)
        this.editedItem.geo = { coordinates: [res.geo.lng, res.geo.lat] };
      else if (!res?.status && res?.message) {
        await this.$store.dispatch("createError", { text: res?.message });
      }
    },
    getFormTitle() {
      const isDefault =
        this.editedItem._id === this.selectedPrincipal.default_location;
      const defaultText = isDefault ? "(Default) " : "";
      const isNew = !this.editedItem._id;
      if (!isNew) {
        return `${this.editedItem.title} ${defaultText}bearbeiten`;
      }
      const createOperator = this.editedItem?.type?.includes("operator");
      const createLocation = this.editedItem?.type?.includes("location");
      if (createOperator === createLocation) {
        return "Veranstalter/Standort anlegen";
      }
      if (createOperator) {
        return "Veranstalter anlegen";
      }
      if (createLocation) {
        return "Standort anlegen";
      }
    },
    autocompleteFilter(item, queryText) {
      return (
        item.first_name
          .toLocaleLowerCase()
          .includes(queryText.toLocaleLowerCase()) ||
        item.last_name.toLowerCase().includes(queryText.toLowerCase())
      );
    },
    updateNoCoordinatesCheckbox() {
      const isNew = !this.editedItem._id;
      if (isNew) {
        this.noCoordinates = false;
        return;
      }
      const geoC = this.editedItem.geo.coordinates;
      if (!geoC[0] || !geoC[1]) {
        this.noCoordinates = true;
      }
    }
  },
  mounted() {
    this.updateNoCoordinatesCheckbox();
  },
  watch: {
    showDialog(val) {
      if (val) {
        this.updateNoCoordinatesCheckbox();
      }
    }
  },
  components: {
    LocationMap,
    OptionListDialog
  }
};
